import React, { useReducer, useState } from 'react'
import { setInstanceInfo } from "../../helpers/helpers";
import InstanceReducer from './InstanceReducer';
import InstanceContext from './InstanceContext';
import { getInstanceService } from '../../services/instance';
import i18next from 'i18next';

const InstanceState = ({ children }) => {

    const InitialState = {
        instanceInfo: null,
        isFetching: true,
        error: false,
        message: null
    }

    const [state, dispatch] = useReducer(InstanceReducer, InitialState)

    const [isReadyForInstall, setIsReadyForInstall] = useState(false);

    const downloadApp = async () => {
        try {
            const promptEvent = window.deferredPrompt;
            promptEvent.prompt();
            await promptEvent.userChoice;
            window.deferredPrompt = null;
            setIsReadyForInstall(false);
        } catch (e) {
            console.log(e)
        }
    }

    const instanceInfoGet = async () => {
        try {
            const response = await getInstanceService();
            if (response.ok) {
                setInstanceInfo(response.data.response);
                await i18next.changeLanguage(response.data.response.language);
                dispatch({
                    type: 'GET_INSTANCE_INFO',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'INSTANCE_INFO_ERROR',
                })
            }
        } catch (e) {
            dispatch({
                type: 'INSTANCE_INFO_ERROR',
            })
            console.log(e);
        }
    }

    return (
        <InstanceContext.Provider
            value={{
                instanceInfoGet,
                instanceInfoState: state,
                isReadyForInstall,
                setIsReadyForInstall,
                downloadApp
            }}
        >
            {children}
        </InstanceContext.Provider>
    )
}

export default InstanceState